import "./filter-tag.scss";
import { P2Button } from "react-bootstrap-common-script";
import { Dispatch, HTMLProps, SetStateAction, useCallback } from "react";
import { SolicitorNotificationTagEnum } from "../../../../models/enum/solicitor-notification-tag.enum";
import useIsMobile from "../../../../hooks/use-is-mobile";

interface FilterTagProps extends HTMLProps<HTMLDivElement> {
  disabled?: boolean;
  tag: SolicitorNotificationTagEnum | null;
  setTag: Dispatch<SetStateAction<SolicitorNotificationTagEnum | null>>;
}

const FilterTag = ({ disabled = true, tag, setTag, ...props }: FilterTagProps) => {
  const { isMobile } = useIsMobile();

  const getStyle = useCallback(
    (targetTag: SolicitorNotificationTagEnum | null) => ({
      ...(tag === targetTag && !disabled ? { backgroundColor: "#085054" } : {}),
      ...(isMobile && { paddingLeft: 16, paddingRight: 16 }),
      height: "fit-content",
      paddingTop: 8,
      paddingBottom: 8,
      textWrap: "wrap",
    }),
    [tag, disabled, isMobile]
  );

  return (
    <div className="polymer-filter-tag__container" {...props}>
      <P2Button
        disabled={disabled}
        onClick={() => setTag(SolicitorNotificationTagEnum.new_update)}
        variant="primary-1"
        style={getStyle(SolicitorNotificationTagEnum.new_update)}
      >
        New updates
      </P2Button>
      <P2Button
        disabled={disabled}
        onClick={() => setTag(SolicitorNotificationTagEnum.action_required)}
        variant="primary-1"
        style={getStyle(SolicitorNotificationTagEnum.action_required)}
      >
        Action required
      </P2Button>
      <P2Button disabled={disabled} onClick={() => setTag(null)} variant="primary-1" style={getStyle(null)}>
        All cases
      </P2Button>
    </div>
  );
};

export { FilterTag };
